import { lazy } from 'react';

import { AuthRoute } from 'modules/auth/routes/auth-route';

const Projects = lazy(() => import('./projects'));

export default {
  routes: [<AuthRoute exact key="/projects" path="/projects" render={() => <Projects />} />],
};
